import {OpeningLogiCtrlStatus} from "../../../../../api/Openings";
import {green, grey, red} from "@mui/material/colors";
import {css} from "@emotion/css";
import {PropsWithChildren, useState} from "react";
import { LogiCtrlOpeningModal } from "./OpeningModal";

export function LogiCtrlOpeningCell(props: {
    opening: number;
    name: string;
    value: OpeningLogiCtrlStatus

    onReload?(): void;
}) {
    const [show, setShow] = useState<HTMLElement|null>(null);

    return (
        <>
            <LogiCtrlStoplightButton onClick={e => {
                e.stopPropagation();
                setShow(e.currentTarget);
            }}>
                <Dot
                    edited={props.value?.doorEdited || props.value?.glazing?.some(g => g.edited) || false}
                    error={props.value?.doorError || props.value?.glazing?.find(g => g.error)?.error || null}
                />
                <Dot
                    edited={props.value?.frameEdited || props.value?.anchorsEdited || false}
                    error={props.value?.frameError || props.value?.anchorsError}
                />
                <Dot edited={props.value?.hardwareEdited || false} error={props.value?.hardwareError} />
            </LogiCtrlStoplightButton>

            {show && props.value && <LogiCtrlOpeningModal
                anchorEl={show}
                opening={props.opening}
                name={props.name}
                onClose={() => setShow(null)}
                value={props.value}
                onReload={props.onReload}
            />}
        </>
    );
}

export function LogiCtrlStoplightButton(props: PropsWithChildren<{
    onClick(e: any): void;
}>) {
    return (
        <button className={stopLightCss} onClick={props.onClick}>
            {props.children}
        </button>
    )
}

const stopLightCss = css({
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    backgroundColor: grey["300"],
    borderRadius: 10,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 3,
    paddingBottom: 3,
    border: `1px solid ${grey["400"]}`,
    cursor: "pointer",
    transition: "background-color 0.15s, box-shadow 0.15s",
    "&:hover": {
        backgroundColor: grey["400"],
        boxShadow: `0 0 0 2px ${grey["500"]}40`,
    },
})

export function Dot(props: {
    edited: boolean;
    error: string | null;
}) {
    if(props.error) return <div className={dotCss} style={{
        backgroundColor: red["500"],
        boxShadow: `0 0 2px 1px ${red["300"]}70`,
    }} />
    if(props.edited) return <div className={dotCss} style={{
        backgroundColor: green["500"],
        boxShadow: `0 0 2px 1px ${green["300"]}70`,
    }} />
    return <div className={dotCss} style={{backgroundColor: grey["500"]}} />
}

const dotSize = 7;
const dotCss = css({
    height: dotSize,
    width: dotSize,
    borderRadius: "50%",
})